export default {
  title01: "Aktuálne počasie",
  title02: "24 hodín",
  title03: "Zobraziť 10-dňovú predpoveď počasia",
  title04: "Index kvality ovzdušia",
  title05: "Zobraziť všetky informácie",
  title06: "VÝCHOD A ZÁPAD SLNKA",
  title07: "FÁZA MESIACA",
  title08: "Ďalší spln",
  title09: "Ďalší nov",
  title10: "DEŇ",
  title11: "NOC",
  title12: "Východ slnka",
  title13: "Západ slnka",
  title14: "Východ mesiaca",
  title15: "Západ mesiaca",
  title16: "Zdroj",
  title17: "Začiatok",
  title18: "Koniec",
  title19: "Použiť aktuálnu polohu",
  title20: "Vyhľadať mesto",
  title21: "Pocitová teplota",
  title22: "Pocitová teplota v tieni",
  title23: "Teraz",
  title24: "Dnes",
  title25: "NE",
  title26: "PON",
  title27: "UTO",
  title28: "STR",
  title29: "ŠTV",
  title30: "PIA",
  title31: "SOB",
  title32: "Načítava sa...",
  title33: "Teraz",
  title34: "Hodinová",
  title35: "Denná",
  title36: "Slnko a Mesiac",
  title37: "Kvalita ovzdušia",
  title38: "Kontakt: xlf550402@gmail.com",
  title39: "Dohoda o ochrane osobných údajov",
  title40: "Autorské práva © comfortweather.com 2020 - 2026. Všetky práva vyhradené.",
  title41: "Údaje poskytnuté",
  title42: "Max",
  title43: "Min",
  title44: "Súhlasiť",
  title45:
    "Ďakujeme, že používate ComfortWeather! Pre lepšiu ochranu vašich práv a záujmov si pred použitím pozorne prečítajte ",
  title46: "Zásady ochrany osobných údajov",
  title47: " .",
  title48: "",
  title49: "Kontakt: xyjph123@gmail.com",
  title50: "Autorské práva © 24hweather.com 2020 - 2026. Všetky práva vyhradené.",
  title51:
    "Ďakujeme, že používate 24hweather! Pre lepšiu ochranu vašich práv a záujmov si pred použitím pozorne prečítajte ",
  title52: "Vaša poloha sa zmenila. Chcete ju aktualizovať?",
  title53: "Potvrdiť",
  title54: "Zrušiť",
  title55: "Späť",
  title56: "Novinky",
  title57: "Aktualizácia počasia...",
  title58: "Aktualizované počasie",
  title59: "Zobraziť všetko",
  title60: "Autorské práva © mobi321.com 2020 - 2026. Všetky práva vyhradené.",
  title61: "Včera",
  title62: "Zajtra",
  title63: "Zobraziť 15-dňovú predpoveď počasia",
  title64: "Dnešné podrobnosti",
  title65: "Rahu Kaal",
  title66: "Indexy životného štýlu",
  title67: "Indexy životného štýlu",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "Ťažké sušenie",
  title103: "Pomalé sušenie",
  title104: "Dobre schne",
  title105: "Rýchle sušenie",
  title106: "Veľmi rýchle sušenie",

  title107: "Nevhodné",
  title108: "Priemerný zážitok",
  title109: "Dobré na vodné radovánky",
  title110: "Veľmi vhodné",
  title111: "Dokonalé podmienky",

  title112: "Podmienky priaznivé pre zdravie",
  title113: "Neutrálne podmienky",
  title114: "Mierne zvýšené riziko",
  title115: "Vysoké riziko",
  title116: "Veľmi vysoké riziko",

  title117: "Nevhodné",
  title118: "Čiastočne vhodné",
  title119: "Dobré na pobyt vonku",
  title120: "Veľmi vhodné",
  title121: "Vynikajúce podmienky",

  title122: "Veľmi suché podmienky",
  title123: "Pravdepodobná suchosť",
  title124: "Mierna suchosť",
  title125: "Nepravdepodobná suchosť",
  title126: "Veľmi nepravdepodobná suchosť",

  title127: "Neodporúča sa",
  title128: "Prijateľné podmienky",
  title129: "Dobrý deň",
  title130: "Veľmi dobré podmienky",
  title131: "Ideálne podmienky",
};
